import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import arrowUpIcon from '../assets/icons/arrow-up.svg';
import logoSymbol from '../assets/icons/logo-symbol.svg';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  // Menu items with navigation paths
  const menuItems = [
    { label: 'Domů', path: '/' },
    { label: 'Blog', path: '/blog' },
    { label: 'Kontakty', path: '/kontakty' }
  ];
  
  const serviceItems = [
    { label: 'Právní konzultace', path: '/consultation-info' },
    { label: 'Generování dokumentů', path: '/documents-info' },
    { label: 'Právní výzkum', path: '/research-info' },
    { label: 'Analýza smluv', path: '/contract-analysis-info' }
  ];
  
  const infoItems = [
    { label: 'O nás', path: '/' }, // placeholder
    { label: 'Ceník & kredity', path: '/pricing' },
    { label: 'Podmínky použití', path: '/podminky-pouziti' },
    { label: 'Cookies', path: '/cookies' },
    { label: 'Obchodní podmínky', path: '/obchodni-podminky' }
  ];

  return (
    <Box sx={{
      width: '100%',
      backgroundColor: '#EDEDED',
      borderTop: '1px solid #DCDCDC',
      py: { xs: 3, sm: 4, md: 5 },
      position: 'relative',
      mt: 'auto'
    }}>
      <Container maxWidth={false} sx={{ 
        maxWidth: '1920px',
        px: { xs: 2, sm: 3, md: 4, lg: '276px' },
        position: 'relative'
      }}>
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: { 
            xs: '1fr', 
            sm: 'repeat(2, 1fr)', 
            md: 'repeat(4, 1fr)', 
            lg: 'repeat(5, 1fr)' 
          },
          gap: { xs: 3, sm: 4 },
          alignItems: 'start'
        }}>
          {/* Logo and Copyright */}
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 2, sm: 3 }
          }}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px'
            }}>
              <Box 
                component="img" 
                src={logoSymbol} 
                alt="Logo" 
                sx={{ 
                  width: '24px', 
                  height: '24px'
                }} 
              />
              <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                <Typography sx={{
                  fontFamily: '"Rajdhani", sans-serif !important',
                  fontSize: '20px',
                  fontWeight: 400,
                  color: '#1F1F1F',
                  letterSpacing: '-0.3px'
                }}>
                  Pravni
                </Typography>
                <Typography sx={{
                  fontFamily: '"Rajdhani", sans-serif !important',
                  fontSize: '20px',
                  fontWeight: 700,
                  color: '#1F1F1F',
                  letterSpacing: '-0.3px'
                }}>
                  BOT
                </Typography>
                <Typography sx={{
                  fontFamily: '"Rajdhani", sans-serif !important',
                  fontSize: '20px',
                  fontWeight: 400,
                  color: '#1F1F1F',
                  letterSpacing: '-0.3px'
                }}>
                  .cz
                </Typography>
              </Box>
            </Box>
            <Typography sx={{
              fontFamily: 'Inter',
              fontWeight: 400,
              fontSize: { xs: '10px', sm: '11px' },
              lineHeight: '14.3px',
              letterSpacing: '0.91%',
              color: '#4C4C4C'
            }}>
              © 2025, PravniBOT.cz
            </Typography>
          </Box>

          {/* MENU Section */}
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 1.5, sm: 2 }
          }}>
            <Typography sx={{
              fontFamily: 'Inter',
              fontWeight: 700,
              fontSize: { xs: '11px', sm: '12px' },
              lineHeight: '18px',
              color: '#1F1F1F'
            }}>
              MENU
            </Typography>
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px'
            }}>
              {menuItems.map((item) => (
                <Typography 
                  key={item.label}
                  onClick={() => navigate(item.path)}
                  sx={{
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: { xs: '11px', sm: '12px' },
                    lineHeight: '18px',
                    color: '#4C4C4C',
                    cursor: 'pointer',
                    '&:hover': {
                      color: '#1F1F1F'
                    }
                  }}
                >
                  {item.label}
                </Typography>
              ))}
            </Box>
          </Box>

          {/* ZAČNĚTE Section */}
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 1.5, sm: 2 }
          }}>
            <Typography sx={{
              fontFamily: 'Inter',
              fontWeight: 700,
              fontSize: { xs: '11px', sm: '12px' },
              lineHeight: '18px',
              color: '#1F1F1F'
            }}>
              ZAČNĚTE
            </Typography>
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px'
            }}>
              {serviceItems.map((item) => (
                <Typography 
                  key={item.label}
                  onClick={() => navigate(item.path)}
                  sx={{
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: { xs: '11px', sm: '12px' },
                    lineHeight: '18px',
                    color: '#4C4C4C',
                    cursor: 'pointer',
                    '&:hover': {
                      color: '#1F1F1F'
                    }
                  }}
                >
                  {item.label}
                </Typography>
              ))}
            </Box>
          </Box>

          {/* INFORMACE Section */}
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 1.5, sm: 2 }
          }}>
            <Typography sx={{
              fontFamily: 'Inter',
              fontWeight: 700,
              fontSize: { xs: '11px', sm: '12px' },
              lineHeight: '18px',
              color: '#1F1F1F'
            }}>
              INFORMACE
            </Typography>
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px'
            }}>
              {infoItems.map((item) => (
                <Typography 
                  key={item.label}
                  onClick={() => navigate(item.path)}
                  sx={{
                    fontFamily: 'Inter',
                    fontWeight: 400,
                    fontSize: { xs: '11px', sm: '12px' },
                    lineHeight: '18px',
                    color: '#4C4C4C',
                    cursor: 'pointer',
                    '&:hover': {
                      color: '#1F1F1F'
                    }
                  }}
                >
                  {item.label}
                </Typography>
              ))}
            </Box>
          </Box>

          {/* Scroll to Top Button */}
          <Box sx={{
            display: { xs: 'none', lg: 'flex' },
            justifyContent: 'flex-end'
          }}>
            <Box 
              onClick={scrollToTop}
              sx={{
                width: '44px',
                height: '44px',
                backgroundColor: '#FFFFFF',
                borderRadius: '999px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                boxShadow: '0px 2px 2px rgba(18, 14, 13, 0.15)',
                cursor: 'pointer',
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0px 4px 8px rgba(18, 14, 13, 0.2)'
                }
              }}
            >
              <Box 
                component="img" 
                src={arrowUpIcon} 
                alt="Scroll to top" 
                sx={{ 
                  width: '24px', 
                  height: '24px'
                }} 
              />
            </Box>
          </Box>
        </Box>

        {/* Mobile Scroll to Top - Fixed Position */}
        <Box
          onClick={scrollToTop}
          sx={{
            display: { xs: 'flex', lg: 'none' },
            position: 'fixed',
            bottom: { xs: 16, sm: 24 },
            right: { xs: 16, sm: 24 },
            width: { xs: '40px', sm: '44px' },
            height: { xs: '40px', sm: '44px' },
            bgcolor: '#1F1F1F',
            backgroundColor: '#1F1F1F',
            borderRadius: '999px',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.25)',
            cursor: 'pointer',
            zIndex: 1000,
            transition: 'all 0.3s ease',
            '&:hover': {
              bgcolor: '#e72f0d',
              backgroundColor: '#e72f0d',
              transform: 'scale(1.1)'
            }
          }}
        >
          <Box 
            component="img" 
            src={arrowUpIcon} 
            alt="Scroll to top" 
            sx={{ 
              width: '20px', 
              height: '20px',
              filter: 'invert(1)'
            }} 
          />
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
